import React, { useContext, useMemo, useEffect, useState } from 'react'
import * as classes from './Info.module.scss'
import cn from 'classnames'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { FormContext } from './../../../../context/index'
import { startAnimationScroll } from '../../../../utils/animations'
import splitTitleV2 from '../../../../utils/splitTitleV2'
import { content } from '../content'

function Info({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const title = useMemo(() => deleteHtmlTag(data.title.value, 'p'), [])
    const blockTitleOne = useMemo(() => deleteHtmlTag(data.blockTitleOne.value, 'p'), [])
    const blockTextOne = useMemo(() => deleteHtmlTag(data.blockTextOne.value, 'p'), [])

    const blockTitleTwo = useMemo(() => deleteHtmlTag(data.blockTitleTwo.value, 'p'), [])
    const blockTextTwo = useMemo(() => deleteHtmlTag(data.blockTextTwo.value, 'p'), [])

    const [titlePrint, setTitlePrint] = useState(title)
    const [subTitleOne, setSubTitleOne] = useState(blockTitleOne)
    const [subTitleTwo, setSubTitleTwo] = useState(blockTitleTwo)

    const socialLabel = content.info.social[lang]
    const hasSocial = data.social && data.social.nodes && data.social.nodes.filter((item) => item.title && item.url).length > 0

    const classAnimationTitle = 'anime-title-contacts-info'
    const classAnimationText = 'anime-text-contacts-info'

    useEffect(() => {
        if (animationStart) {
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'textFull', className: classAnimationText },
            { type: 'title', className: classAnimationTitle }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <div className={cn(classes.Wrapper, { [classes.LangHY]: lang === 'hy' })}>
            {title ? <p className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: titlePrint }} /> : null}

            {subTitleOne || blockTextOne ? (
                <div className={classes.Office}>
                    {subTitleOne ? (
                        <div className={`${classes.SubTitle} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: subTitleOne }} />
                    ) : null}

                    {blockTextOne ? (
                        <p className={`${classes.Address} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: blockTextOne }} />
                    ) : null}
                </div>
            ) : null}

            {(subTitleTwo || blockTextTwo) && (subTitleOne || blockTextOne) ? <div className={`${classes.Separator} contacts-separator`} /> : null}

            {subTitleTwo || blockTextTwo ? (
                <div className={classes.Department}>
                    {subTitleTwo ? (
                        <div className={`${classes.SubTitle} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: subTitleTwo }} />
                    ) : null}

                    {blockTextTwo ? (
                        <p className={`${classes.Address} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: blockTextTwo }} />
                    ) : null}
                </div>
            ) : null}

            {hasSocial && (subTitleTwo || blockTextTwo) ? <div className={`${classes.Separator} contacts-separator`} /> : null}

            {hasSocial ? (
                <div className={classes.Social}>
                    <div className={`${classes.SubTitle} ${classAnimationTitle}`}>{socialLabel}</div>

                    <div className={classes.SocialLinks} data-count={data.social.nodes.filter((item) => item.title && item.url).length}>
                        {data.social.nodes.map((item, index) => {
                            if (item.url && item.title) {
                                return (
                                    <a className={`${classAnimationText}`} href={item.url} key={index} target='_blank' rel='noopener noreferrer'>
                                        {item.title}
                                    </a>
                                )
                            } else {
                                return false
                            }
                        })}
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default Info
